module.exports = __webpack_public_path__ + "img/kv.8b26e7c3.jpg";